import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "./baseQueryWithReauth";

export const healthApi = createApi({
  reducerPath: "healthApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getMonthSteps: builder.query({
      query: (client_code) => ({
        url: `api/mh/activities/month`,
        method: "GET",
        params: { client_code: client_code },
      }),
    }),
    getTodaySteps: builder.query({
      query: ({ actualUserClientCode, selectedDate }) => ({
        url: `api/mh/activities/weekly`,
        method: "GET",
        params: { start_date: selectedDate, end_date: selectedDate, client_code: actualUserClientCode },
      }),
    }),
    createClientCode: builder.mutation({
      query: (payload) => ({
        url: `api/mh/activity-history`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetMonthStepsQuery,
  useGetTodayStepsQuery,
  useCreateClientCodeMutation,
} = healthApi;
